// Added by Sejune Oh on 2019-03-19
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { Fragment } from 'react'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Prime elements
import { TableCell, TableSortLabel } from '@/components/_primes'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
import { TableHeaderPartialProps } from '../../TableContainer'

interface SortableTableHeaderFCProps extends TableHeaderPartialProps {}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const SortableTableHeader = (props: SortableTableHeaderFCProps) => {
    const { customColSpan } = props
    return (
        <Fragment>
            {props.headerProps.map(({ key, align, disablePadding, label, isSortable }, index) => {
                const sortActive = props.orderBy === key

                return (
                    <TableCell
                        style={{ paddingRight: 12, paddingLeft: 12 }}
                        colSpan={customColSpan ? customColSpan[index] : 2}
                        key={index}
                        align={align}
                        padding={disablePadding ? 'none' : 'normal'}
                        sortDirection={sortActive ? props.order : false}
                    >
                        {isSortable ? (
                            <TableSortLabel
                                active={sortActive}
                                direction={props.order}
                                onClick={props.onSortClick ? props.onSortClick(key) : () => {}}
                                title={label}
                                data-cy-label={label}
                            >
                                {label}
                            </TableSortLabel>
                        ) : (
                            label
                        )}
                    </TableCell>
                )
            })}
        </Fragment>
    )
}

export default SortableTableHeader
